import { Modal, Select, Spin, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import {
  getAllSponsor,
  getSponsorsForVaccine,
  updateSponsorForVaccine,
} from '../../services/api/cashless-vaccination';
import '../../App.css';

const AddSponsors = ({
  sponsor,
  vaccineId,
  vaccineName,
  onCancel,
  refreshTableData,
}) => {
  const [allSponsor, setAllSponsorName] = useState([]);
  const [selectedSponsors, setSelectedSponsors] = useState([]);
  const [fetching, setFetching] = useState(false);
  const searchTimer = useRef(null);

  useEffect(() => {
    getSponsorsForVaccine(vaccineId)
      .then((response) => {
        if (response.body.message === 'success') {
          setSelectedSponsors(response.body.data.map((e) => e.sponsorId));
          setAllSponsorName(response.body.data);
        }
      })
      .catch((err) => {
        message.error('Failed to load existing sponsors');
      });
  }, []);

  const handleSearch = (value) => {
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    if (!value || value.length < 2) {
      return;
    }
    searchTimer.current = setTimeout(() => {
      setFetching(true);
      getAllSponsor(value)
        .then((response) => {
          if (response.body.message === 'success') {
            const searchResults = response.body.data;
            const selectedSet = new Set(selectedSponsors);
            const existingSelected = allSponsor.filter((s) =>
              selectedSet.has(s.sponsorId)
            );
            const existingSelectedIds = new Set(
              existingSelected.map((s) => s.sponsorId)
            );
            const newResults = searchResults.filter(
              (s) => !existingSelectedIds.has(s.sponsorId)
            );
            setAllSponsorName([...existingSelected, ...newResults]);
          }
        })
        .catch((err) => {
          message.error('Failed to search sponsors');
        })
        .finally(() => {
          setFetching(false);
        });
    }, 500);
  };

  const handleSelectChange = (selectedItems) => {
    setSelectedSponsors(selectedItems);
  };

  const submitSponsorsVaccination = () => {
    updateSponsorForVaccine(selectedSponsors, vaccineId)
      .then((response) => {
        if (response.body.message === 'success') {
          onCancel();
          refreshTableData();
          message.success('Updated');
        }
      })
      .catch((error) => {
        message.error('Failed to update sponsors');
      });
  };

  return (
    <Modal
      title={`Add Sponsor for vaccine Id ${vaccineId} - ${
        vaccineName.length > 20
          ? vaccineName.substring(0, 20) + '......'
          : vaccineName
      }`}
      visible={sponsor}
      onCancel={onCancel}
      className="custom-modal"
      onOk={submitSponsorsVaccination}
      okText="Save"
      okButtonProps={{ style: { backgroundColor: '#008f7b', color: 'white' } }}
      cancelButtonProps={{
        style: { backgroundColor: '#008f7b', color: 'white' },
      }}
    >
      <div>
        <Select
          mode="multiple"
          style={{
            width: '100%',
          }}
          showSearch
          onSearch={handleSearch}
          onChange={handleSelectChange}
          placeholder="Type to search sponsors"
          value={selectedSponsors}
          filterOption={false}
          notFoundContent={fetching ? <Spin size="small" /> : null}
          className="custom-select"
        >
          {allSponsor.map((s) => {
            return (
              <Select.Option key={s.sponsorId} value={s.sponsorId}>
                {s.sponsorName}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </Modal>
  );
};

export default AddSponsors;
